module.exports = __webpack_public_path__ + "static/media/instagram_icon.671374b0.png";